import React, { Component } from 'react';
import AuthenticatorContext from './authenticatorcontext'
import {withRouter} from "react-router-dom";
import {withApplicationState} from "react-application-state";
import PropTypes from 'prop-types';
import jwtDecode from 'jwt-decode';
import applicationConfig from './../../../config/application';

class Authenticate extends Component {

    static propTypes = {
        appState: PropTypes.object,
    }

    static defaultProps = {
        appState: {
            state: {},
            actions: {}
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false,
            userName: '',
            userId: ''
        };
    }

    static validateToken = (token) => {
        try {
            const decoded = jwtDecode(token);
            if(decoded.aud === applicationConfig.JWT.allowedAudience && decoded.iss === applicationConfig.JWT.allowedIssuer)
                return decoded;
        }catch(_){ }
        return false;
    }

    static getDerivedStateFromProps = (nextProps, oldState) => {
        const tokenInfo = Authenticate.validateToken(nextProps.appState.state.jwtToken);
        let newState = {
            isAuthenticated: false,
            userName: '',
            userId: '',
        };
        if(tokenInfo)
            newState = {
                isAuthenticated: true,
                userName: tokenInfo.name,
                userId: tokenInfo.microsoftId
            };
        if(oldState.userName !== newState.userName || oldState.userId !== newState.userId)
            nextProps.appState.actions.setUserInfo(newState.userName, newState.userId);
        return newState;

    }

    render() {
        return (
            <AuthenticatorContext.Provider value={this.state}>
                {this.props.children}
            </AuthenticatorContext.Provider>
        )
    }
}

export const Authenticator = withApplicationState(withRouter(Authenticate));
